module.exports = __webpack_public_path__ + "static/img/1019.bfee215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1019.jpg
// module id = 201
// module chunks = 0